import { Page, Spinner } from "@adfenix/alexandria";
import { Modal } from "components/Modal";

import { PropertyServiceApi } from "api/services";
import { useQuery } from "@tanstack/react-query";

import { useNavigate, useParams } from "react-router-dom";
import { InviteSellerForm } from "./InviteSellerForm";

const {
  property: { authV2PropertyDetail }
} = PropertyServiceApi;

export const InviteSellerFromEmail = () => {
  const { hqId } = useParams<"hqId">();
  const { propertyId } = useParams<"propertyId">();

  if (!propertyId || !hqId) {
    throw "No id!";
  }
  const navigate = useNavigate();

  const { data, isLoading } = useQuery(
    ["getPropertybyId", propertyId],
    () => authV2PropertyDetail(propertyId),
    { enabled: Boolean(propertyId), retry: false }
  );

  if (isLoading) {
    return (
      <Page>
        <Spinner centered />
      </Page>
    );
  }

  return (
    <Modal
      show={true}
      onClose={() => navigate(`/customer/hq/${hqId}/property`)}
    >
      <Modal.Card>
        <InviteSellerForm
          location={data?.address || ""}
          propertyId={propertyId}
          hqId={hqId}
        />
      </Modal.Card>
    </Modal>
  );
};
